import { useEffect } from 'react';
import Header from '../../../components/base/Header';
import Footer from '../../../components/base/Footer';
import { Link } from 'react-router-dom';

export default function FlowerShopVisitBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-green-500 to-emerald-500">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-store-line text-5xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              🌼 花屋めぐりシリーズ【第1弾】オザキフラワーパークに行ってきました！
            </h1>
            <p className="text-xl text-white/90 mb-6">
              ──息子と一緒に花の楽園を大冒険──
            </p>
            <div className="flex items-center justify-center gap-4 text-white/90">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                2025年11月30日
              </span>
              <span className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                ももちゃん
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/a9e025037dc3745007cfadb6273b94dc.png"
                alt="オザキフラワーパークの店内"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                こんにちは！ももちゃんです🌸
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                花が大好きな息子と一緒に、ついに花屋さん巡りを始めることにしました！<br />
                記念すべき第1弾は...今までで最大規模の花屋さんに挑戦です✨
              </p>
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 my-6 text-center border-l-4 border-green-400">
                <p className="text-green-800 font-bold text-xl">
                  🚗 オザキフラワーパーク（東京都練馬区）へ行ってきました！
                </p>
              </div>
            </div>

            {/* Section 1 */}
            <div className="mb-12 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-emerald-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🏪</span>
                圧倒的なスケール感に圧倒！
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  とにかく広い！そしてすべてのコーナーが本気です！
                </p>
                <p>
                  入り口をくぐった瞬間から、「植物園じゃない？」と思うほどのスケール感に息子も私も驚きました😲
                </p>
                
                <div className="grid md:grid-cols-2 gap-4 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-emerald-400">
                    <h3 className="text-xl font-bold text-emerald-700 mb-2 flex items-center">
                      🌿 観葉植物のジャングルゾーン
                    </h3>
                    <p>まるでジャングル！大型植物から小さな苗まで、種類の豊富さに目を奪われます。</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-purple-400">
                    <h3 className="text-xl font-bold text-purple-700 mb-2 flex items-center">
                      🌺 洋ランの上品エリア
                    </h3>
                    <p>胡蝶蘭をはじめ、上品で美しい洋ランがずらり。まるで宝石箱のよう✨</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-orange-400">
                    <h3 className="text-xl font-bold text-orange-700 mb-2 flex items-center">
                      🌵 エアープランツ＆多肉の宝庫
                    </h3>
                    <p>息子が一番興奮したエリア！珍しい種類がたくさんで、選ぶのが大変でした。</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md border-l-4 border-pink-400">
                    <h3 className="text-xl font-bold text-pink-700 mb-2 flex items-center">
                      🌸 季節の花コーナー
                    </h3>
                    <p>見ているだけで胸が躍る美しい花々。季節感溢れるディスプレイも素敵でした。</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-12 bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-pink-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">👶</span>
                息子との楽しい発見タイム
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <div className="bg-white rounded-2xl p-6 my-6 border-l-4 border-pink-400">
                  <p className="text-pink-700 font-medium text-lg">
                    息子の第一声：「ここに住みたい！」😂
                  </p>
                </div>
                <p>
                  特にエアープランツの棚の前で興奮が止まらず、<br />
                  一つ一つの植物を丁寧に観察していました。
                </p>
                <p>
                  実は昨年、夏越しに成功したシクラメンたちとの出会いもここなんです🌸<br />
                  思い出の場所でもあるので、来るたびに特別な気持ちになります。
                </p>
                <p>
                  今回もまた、新しい仲間をお迎えしようと<br />
                  親子で真剣に相談しながら探し回りました✨
                </p>
                <div className="bg-gradient-to-r from-green-100 to-emerald-100 rounded-2xl p-6 my-6">
                  <p className="text-green-800 font-medium">
                    息子が選んだのは...小さなエアープランツ！<br />
                    「この子の名前は『みどりちゃん』にする」と嬉しそうでした🌿
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-12 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-blue-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">⭐</span>
                家族で楽しめる最高のスポット
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ゆっくり見て回ると、なんと2時間以上があっという間でした！
                </p>
                <p>
                  駐車場もしっかりあるので、家族でのお出かけにぴったり🚗<br />
                  重い鉢植えを買っても安心して持ち帰れるのが嬉しいポイントです。
                </p>
                <p>
                  店員さんも植物について詳しく教えてくれて、<br />
                  初心者にもとても優しい雰囲気でした😊
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-blue-200">
                  <p className="text-2xl font-bold text-blue-800">
                    次は春にまた行く予定です🌸<br />
                    桜の季節の花たちにも会いに行きたい！
                  </p>
                </div>
              </div>
            </div>

            {/* Store Information */}
            <div className="mb-12 bg-gradient-to-br from-gray-50 to-slate-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">📍</span>
                店舗情報
              </h2>
              <div className="space-y-4 text-gray-700">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <span className="font-bold text-gray-800 w-20">店名：</span>
                      <span>オザキフラワーパーク</span>
                    </div>
                    <div className="flex items-center">
                      <span className="font-bold text-gray-800 w-20">住所：</span>
                      <span>東京都練馬区石神井台4-6-32</span>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <span className="font-bold text-gray-800 w-20">駐車場：</span>
                      <span>あり 🚗</span>
                    </div>
                    <div className="flex items-center">
                      <span className="font-bold text-gray-800 w-20">営業時間：</span>
                      <span>10:00〜（最新情報は公式確認）</span>
                    </div>
                  </div>
                </div>
                <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
                  <p className="text-sm text-gray-600">
                    <i className="ri-information-line mr-2"></i>
                    営業時間や定休日は変更される場合があります。お出かけ前に公式サイトでご確認ください。
                  </p>
                </div>
              </div>
            </div>

            {/* Closing Message */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8 text-center">
              <h2 className="text-3xl font-bold text-green-800 mb-6">
                🌼 花屋めぐりシリーズ、引き続き更新中！
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                息子と一緒に、これからもたくさんの花屋さんを巡っていきます🚶‍♀️<br />
                きっと素敵な出会いがたくさん待っているはず✨
              </p>
              <p className="text-lg font-bold text-green-800">
                次はどこの花屋さんに行こうかな？お楽しみに😊
              </p>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-12">
              <span className="px-4 py-2 bg-green-100 text-green-700 text-sm rounded-full">
                #花屋めぐり
              </span>
              <span className="px-4 py-2 bg-green-100 text-green-700 text-sm rounded-full">
                #オザキフラワーパーク
              </span>
              <span className="px-4 py-2 bg-green-100 text-green-700 text-sm rounded-full">
                #親子でお出かけ
              </span>
              <span className="px-4 py-2 bg-green-100 text-green-700 text-sm rounded-full">
                #植物好き
              </span>
              <span className="px-4 py-2 bg-green-100 text-green-700 text-sm rounded-full">
                #練馬区
              </span>
            </div>

            {/* Back Button */}
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                エッセイ一覧に戻る
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-emerald-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-green-800 mb-8 text-center">
              他のブログ記事も読む
            </h2>
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center text-green-600 hover:text-green-700 font-medium transition-colors"
              >
                すべての記事を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}